/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
// nodejs library that concatenates classes
//import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  /*
  Button,
  ButtonGroup,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,*/
  Row,
  Col,
  Button,
  ButtonGroup,
  Collapse,/*
  UncontrolledTooltip,*/
} from "reactstrap";

// core components
import {
  //chartExample1,
  chartExample2,
  chartExample3,
  chartExample4,
} from "../variables/charts.js";
import ChartDataConverter, {ChartDataConverterBars} from "../variables/chartConverter";
import api from "../../utils/axiosApi.js";
import classNames from "classnames";
import Highlighted from "../../utils/Highlighted.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../components/SearchCalendarHeader/styles.css'

function Dashboard(props) {
  const localToken = window.sessionStorage.getItem('jwtuser')|| localStorage.getItem('jwtuser')
  /*const [actualMetric, setactualMetric] = React.useState("data1");
  const setBgChartData = (name) => {
    setactualMetric(name);
  };*/
  const [dataChartUser, setDataChartUser] = useState(chartExample2)
  const [lastUsersNumber, setLastUsersNumber] = useState(0)
  const [dataChartCalendars, setDataChartCalendars] = useState({lineData: chartExample4, numberCal:0})
  const [dataChartNumberAct, setDataChartNumberAct] = useState({lineData: chartExample4, numberCal:0})
  const [dataDurationSessions, setDataDurationSessions] = useState({lineData: chartExample4, numberCal:0})
  const [dataChartCalendarShared, setDataChartCalendarShared] = useState({lineData: chartExample2, numberCal:0})
  const [dataUsersCalendars, setDataUsersCalendars] = useState({barData: chartExample3, numberCal:0})
  /*metrics*/
  const [actualMetric, setactualMetric] = useState('openOneClick')
  const [actualQrMetric, setactualQrMetric] = useState('openQrClick')
  const [dataMetrics, setDataMetrics] = useState({
    landingViews: {lineData: chartExample2, numberCal:0},
    cheapsFlights: {lineData: chartExample2, numberCal:0},
    openOneClick: {lineData: chartExample2, numberCal:0},
    successOneClick: {lineData: chartExample2, numberCal:0},
    optimalDay: {lineData: chartExample2, numberCal:0},
    ArrivalFrom: {barData: chartExample3, numberCal:0},
    openQrClick: {lineData: chartExample2, numberCal:0},
    qrDownload: {lineData: chartExample3, numberCal:0},
  })
  //cities
  const [dataCities, setDataCities] = useState({
    city: {_id: '', name:''},
    bar: {data: chartExample3, numberCal:0},
    activityLine: {lineData: chartExample2, numberCal:0},
  })
  //activites
  const [dataActivitys, setDataActivitys] = useState({
    activity: {_id: '', name:''},
    bar: {data: chartExample3, numberCal:0},
    activityLine: {lineData: chartExample2, numberCal:0},
  })
  //blog
  const [datablogs, setDatablogs] = useState({
    blog: {_id: '', name:''},
    bar: {data: chartExample3, numberCal:0},
    blogLine: {lineData: chartExample2, numberCal:0},
  })
  //handler search activitie
  
  const [activitieId, setActivitieId] = useState('')
  const [state, setState] = useState({
    show:false,
    loading:false,
  })
  
  const [citySearch, setCitySearch] = useState({
      fullName:'',
      _id:''
  })
  const [show, setShow] = useState(false)
  const [places, setPlaces] = useState([])
  useEffect(() => {
    const requestmetrics =async () => {
      try {
        const optimalM = await api.get('/metrics/getOptimalMetric',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const PagesMetrics = await api.get('/metrics/getPagesMetric',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const arrivalFrom = await api.get('/metrics/getArrivalFrom',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const QrClicks = await api.get('/metrics/getQrClicks',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const dataLanding = ChartDataConverter(PagesMetrics.data.landingData,'green')
        const datacheapFlights = ChartDataConverter(PagesMetrics.data.cheapFlightsData,'green')
        const dataOneClickCalendarOpen = ChartDataConverter(optimalM.data.OneClickCalendarOpenData)
        const dataOneClickCalendarSuccess = ChartDataConverter(optimalM.data.totalOneClickCalendarSuccessData)
        const dataOptimalDay = ChartDataConverter(optimalM.data.OptimalDayData)
        const dataQrClicks = ChartDataConverter(QrClicks.data.OpenQrPopData)
        const dataQrDonloads = ChartDataConverter(QrClicks.data.totalQrDownloadData)
        const databarsActs = ChartDataConverterBars(arrivalFrom.data.ArrivalFromData)
        setDataMetrics({
          landingViews: {lineData: dataLanding, numberCal:PagesMetrics.data.landingNumber},
          cheapsFlights: {lineData: datacheapFlights, numberCal:PagesMetrics.data.cheapFlightsNumber},
          openOneClick: {lineData: dataOneClickCalendarOpen, numberCal:optimalM.data.OneClickCalendarOpenNumber},
          successOneClick: {lineData: dataOneClickCalendarSuccess, numberCal:optimalM.data.totalOneClickCalendarSuccessNumber},
          optimalDay: {lineData: dataOptimalDay, numberCal:optimalM.data.OptimalDayNumber},
          ArrivalFrom: {barData: databarsActs, numberCal:0},
          openQrClick: {lineData: dataQrClicks, numberCal:QrClicks.data.OpenQrPopNumber},
          qrDownload: {lineData: dataQrDonloads, numberCal:QrClicks.data.totalQrDownloadNumber},

        })
      } catch (error) {
        //console.log(error)
      }
    }
    /*const requestActivites =async () => {
      try {
        const activites = await api.get('/metrics/getActivitiesMetric',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const databarsActs = ChartDataConverterBars(activites.data.activitesMoreView)
        const dataLineAct = ChartDataConverter(activites.data.activityClickData, 'green', 'MM-DD', 'YY-MM-DD')
        setDataActivitys({
          activity: {_id: '', name:activites.data.activity?.name},
          bar: {data: databarsActs, numberCal:0},
          activityLine: {lineData: dataLineAct, numberCal:0},
        })
      } catch (error) {
        //console.log(error)
      }
    }*/
    const requestDurations =async () => {
      try {
        const Durations = await api.get('/metrics/getDurationSessions',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const dataLineAct = ChartDataConverter(Durations.data.DurationSessionData, 'green')
        setDataDurationSessions({
          lineData: dataLineAct, numberCal:Durations.data.promDurationSession
        })
      } catch (error) {
        //console.log(error)
      }
    }
    const requestLastUsers =async () => {
      try {
        const respCalendars = await api.get('/agendacalendar/getLastCalendars',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const resp = await api.get('/user/getLastUsers',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const data = ChartDataConverter(resp.data.data)
        const dataCalendars = ChartDataConverter(respCalendars.data.data,'green')
        const dataPromAct = ChartDataConverter(respCalendars.data.numeroPromAct,'green')
        const dataChartCalendarShared = ChartDataConverter(respCalendars.data.calendarShared)
        setDataChartUser(data)
        setDataChartCalendars(
          {lineData: dataCalendars, numberCal:respCalendars.data.totalCalendars}
          )
        setDataChartNumberAct({lineData: dataPromAct, numberCal:respCalendars.data.totalCalendars})
        setDataChartCalendarShared({lineData: dataChartCalendarShared, numberCal:respCalendars.data.totalcalendarShared})
        setLastUsersNumber(resp.data.numberUsers)
      } catch (error) {
        //console.log(error)
      }
    }
    const requestUsersCalendars =async () => {
      try {
        const activites = await api.get('/metrics/getUsersNumberCalendar',{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const databarsActs = ChartDataConverterBars(activites.data.usersNumberCalendarData)
        setDataUsersCalendars({
          barData: databarsActs, numberCal:activites.data.promCalendars
        })
      } catch (error) {
        //console.log(error)
      }
    }
    const requestcities =async () => {
      try {
        const cities = await api.get(`/metrics/getcitiesMetric`,{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const databarsActs = ChartDataConverterBars(cities.data.citiesMoreView)
        const dataLineAct = ChartDataConverter(cities.data.cityClickData, 'green', 'MM-DD', 'YY-MM-DD')
        setDataCities({
          city: cities.data.city,
          bar: {data: databarsActs, numberCal:0},
          activityLine: {lineData: dataLineAct, numberCal:0},
        })
      } catch (error) {
        //console.log(error)
      }
    }
    requestmetrics()
    requestDurations()
    requestcities()
    requestLastUsers()
    requestUsersCalendars()
    return () => {
      
    }
  }, [localToken])

  useEffect(() => {
    const requestActivites =async () => {
      try {
        const activites = await api.get(`/metrics/getActivitiesMetric?idActivite=${activitieId}`,{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const databarsActs = ChartDataConverterBars(activites.data.activitesMoreView)
        const dataLineAct = ChartDataConverter(activites.data.activityClickData, 'green', 'MM-DD', 'YY-MM-DD')
        setDataActivitys({
          activity: activites.data.activity,
          bar: {data: databarsActs, numberCal:0},
          activityLine: {lineData: dataLineAct, numberCal:0},
        })
      } catch (error) {
        //console.log(error)
      }
    }
    requestActivites()
    return () => {
      
    }
  }, [activitieId])
  useEffect(() => {
    const requestblogs =async () => {
      try {
        const blogs = await api.get(`/metrics/getBlogMetric?id=`,{
          headers : {
              Authorization: `Bearer ${localToken}`
          }
        })
        const databarsActs = ChartDataConverterBars(blogs.data.blogsMoreView)
        const dataLineAct = ChartDataConverter(blogs.data.blogClickData, 'green', 'MM-DD', 'YY-MM-DD')
        setDatablogs({
          blog: blogs.data.blog,
          bar: {data: databarsActs, numberCal:0},
          blogLine: {lineData: dataLineAct, numberCal:0},
        })
      } catch (error) {
        //console.log(error)
      }
    }
    requestblogs()
    return () => {
      
    }
  }, [])
  
  
  const handleChange= async (e) => {
    setCitySearch({
        fullName:e.target.value,
        _id:''
    })
    if(e.target.value !== '') {
        if(places.length === 0){
            setState({
                loading:true
            })
        }
        try {
            setShow(true)
            const resp = await api.post(`/adminsplaces/getFiltered`,{
                namePlace:e.target.value
            })
            if(resp.data.query === e.target.value) {
                setPlaces(resp.data.data)
                setState({
                    loading:false
                })
            }
        } catch (error) {
            setPlaces([])
            setState({
                loading:false
            })
            //console.log(error)
        }
    } else {setPlaces([]); 
        setShow(false)
        setState({
        loading:false
    })}
}
  return (
    <>
      <div className="content">
        <Row>
          <Col xs="12">
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col className="text-left" sm="6">
                    <h5 className="card-category">Optimals clicks</h5>
                    <CardTitle tag="h2"></CardTitle>
                  </Col>
                  <Col sm="6">
                    <ButtonGroup
                      className="btn-group-toggle float-right"
                      data-toggle="buttons"
                    >
                      <Button
                        tag="label"
                        className={classNames("btn-simple", {
                          active: actualMetric === "openOneClick",
                        })}
                        color="info"
                        id="0"
                        size="sm"
                        onClick={() => setactualMetric("openOneClick")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          One Click Calendar open
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="1"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: actualMetric === "successOneClick",
                        })}
                        onClick={() => setactualMetric("successOneClick")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          One click Confirmed
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-gift-2" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="2"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: actualMetric === "optimalDay",
                        })}
                        onClick={() => setactualMetric("optimalDay")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          optimal By day
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-tap-02" />
                        </span>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataMetrics[actualMetric].lineData.data}
                    options={dataMetrics[actualMetric].lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        
        <Row>
          <Col lg="6">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Ultimos Calendarios Creados</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-bell-55 text-info" /> Total de calendarios: {dataChartCalendars.numberCal}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataChartCalendars.lineData.data}
                    options={dataChartCalendars.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Cantidad promedio de actividades por calendario</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-bell-55 text-info" />
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataChartNumberAct.lineData.data}
                    options={dataChartNumberAct.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="12">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Calendarios compartidos</h5>
                <CardTitle tag="h3">
                  total de calendarios compartidos {dataChartCalendarShared.numberCal}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataChartCalendarShared.lineData.data}
                    options={dataChartCalendarShared.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Clicks desde otras paginas</h5>
                <CardTitle tag="h3">
                  redireccionado
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                <Bar
                    data={dataMetrics.ArrivalFrom.barData.data}
                    options={dataMetrics.ArrivalFrom.barData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="8">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Duracion de las Sesiones (en Minutos)</h5>
                <CardTitle tag="h3">
                  Duracion promedio total: {dataDurationSessions.numberCal} Min
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataDurationSessions.lineData.data}
                    options={dataDurationSessions.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xs="12">
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col className="text-left" sm="6">
                    <h5 className="card-category">QR clicks</h5>
                    <CardTitle tag="h2"></CardTitle>
                  </Col>
                  <Col sm="6">
                    <ButtonGroup
                      className="btn-group-toggle float-right"
                      data-toggle="buttons"
                    >
                      <Button
                        color="info"
                        id="1"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: actualQrMetric === "openQrClick",
                        })}
                        onClick={() => setactualQrMetric("openQrClick")}
                      >
                        <span className="d-none d-sm-block">
                          QR vistos
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-gift-2" />
                        </span>
                      </Button>
                      <Button
                        color="info"
                        id="2"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: actualQrMetric === "qrDownload",
                        })}
                        onClick={() => setactualQrMetric("qrDownload")}
                      >
                        <span className="d-none d-sm-block">
                          QR descargados
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-tap-02" />
                        </span>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataMetrics[actualQrMetric].lineData.data}
                    options={dataMetrics[actualQrMetric].lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Visitas al Landing</h5>
                <CardTitle tag="h3">
                  total de visitas {dataMetrics.landingViews.numberCal}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataMetrics.landingViews.lineData.data}
                    options={dataMetrics.landingViews.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Visitas al cheap flight</h5>
                <CardTitle tag="h3">
                  total de visitas {dataMetrics.cheapsFlights.numberCal}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataMetrics.cheapsFlights.lineData.data}
                    options={dataMetrics.cheapsFlights.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          
          <Col lg="12">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Ultimos Usuarios registrados</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-bell-55 text-info" /> total de usuarios: {lastUsersNumber}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataChartUser.data}
                    options={dataChartUser.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          
          <Col lg="12">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Numero de calendarios por usuario</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-delivery-fast text-primary" />Cantidad de calendarios promedio: {dataUsersCalendars.numberCal}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Bar
                    data={dataUsersCalendars.barData.data}
                    options={dataUsersCalendars.barData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xs={12}  className=' mb-2 p-0'>
            <form onSubmit={(e)=>{e.preventDefault();setActivitieId('');setCitySearch({
                          fullName:''
                      })} } style={{zIndex:1}} className='SearchInfoCont SearchCitiesCont d-flex' >
              <input style={{height:'35px'}} onChange={handleChange} className='searchinput' value={citySearch.fullName} placeholder={'buscar actividad'} type='search'></input>
              <button className='searchbutton searchbuttoncities  rounded-circle mt-0' type='submit'><FontAwesomeIcon icon='times'></FontAwesomeIcon></button>
                  
              <Collapse  style={{position: 'absolute', top:'45px', left:0, right:0}} isOpen={(show)}>
                <ul style={{zIndex: 300, position:'relative', top:0}} className='optionsSearch'> 
                  {(!state.loading) && places.map(e => {
                  
                  const cityText = Highlighted({text:e.name, highlight:citySearch.fullName})
                  return (
                    <li className='optionAutoComplete' onClick={() => {
                      setCitySearch({
                          fullName:e.name,
                          _id:e._id
                      })
                      setActivitieId(e._id)
                      setState({
                          loading:false
                      })
                      setShow(false)
                      }}>{cityText}
                    </li>
                  )}
                  )}
                  {(places.length===0 && !state.loading ) && <li className='optionAutoComplete'>actividad no encontrada<span></span></li> }
                  {(!state.loading) ? <></> : 
                      <div className='d-flex justify-content-center' style={{color: '#E5E9F2' ,fontSize: '50px', width:'100%', padding: '5px 0'}}>
                      <FontAwesomeIcon spin icon='circle-notch'/>
                  </div>
                  }
                </ul>
              </Collapse>
            </form>
          </Col>
          <Col lg="4">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Actividades más visitadas</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-delivery-fast text-primary" />{" "}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Bar
                    data={dataActivitys.bar.data.data}
                    options={dataActivitys.bar.data.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>

          
          <Col lg="8">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">visitas diarias</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-send text-success" /> {dataActivitys.activity.name}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataActivitys.activityLine.lineData.data}
                    options={dataActivitys.activityLine.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          {
            //blogs---------------------------------------------------------------------------------------
          }
          
          <Col lg="4">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Blogs más visitados</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-delivery-fast text-primary" />{" "}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Bar
                    data={datablogs.bar.data.data}
                    options={datablogs.bar.data.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>

          
          <Col lg="8">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">visitas diarias</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-send text-success" /> {datablogs.blog.name}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={datablogs.blogLine.lineData.data}
                    options={datablogs.blogLine.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          {
            //ciudades mas solicitadas
          }
          <Col lg="4">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">ciudades más visitadas</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-delivery-fast text-primary" />{" "}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Bar
                    data={dataCities.bar.data.data}
                    options={dataCities.bar.data.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>

          
          <Col lg="8">
            <Card className="card-chart">
              <CardHeader>
                <h5 className="card-category">Clicks diarios</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-send text-success" /> {dataCities.city.name}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={dataCities.activityLine.lineData.data}
                    options={dataCities.activityLine.lineData.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>

        </Row>
      </div>
    </>
  );
}
/*4
tablas

          <Col lg="6" md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Simple Table</CardTitle>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Name</th>
                      <th>Country</th>
                      <th>City</th>
                      <th className="text-center">Salary</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Dakota Rice</td>
                      <td>Niger</td>
                      <td>Oud-Turnhout</td>
                      <td className="text-center">$36,738</td>
                    </tr>
                    <tr>
                      <td>Minerva Hooper</td>
                      <td>Curaçao</td>
                      <td>Sinaai-Waas</td>
                      <td className="text-center">$23,789</td>
                    </tr>
                    <tr>
                      <td>Sage Rodriguez</td>
                      <td>Netherlands</td>
                      <td>Baileux</td>
                      <td className="text-center">$56,142</td>
                    </tr>
                    <tr>
                      <td>Philip Chaney</td>
                      <td>Korea, South</td>
                      <td>Overland Park</td>
                      <td className="text-center">$38,735</td>
                    </tr>
                    <tr>
                      <td>Doris Greene</td>
                      <td>Malawi</td>
                      <td>Feldkirchen in Kärnten</td>
                      <td className="text-center">$63,542</td>
                    </tr>
                    <tr>
                      <td>Mason Porter</td>
                      <td>Chile</td>
                      <td>Gloucester</td>
                      <td className="text-center">$78,615</td>
                    </tr>
                    <tr>
                      <td>Jon Porter</td>
                      <td>Portugal</td>
                      <td>Gloucester</td>
                      <td className="text-center">$98,615</td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>

          
        <Row>
          <Col lg="6" md="12">
            <Card className="card-tasks">
              <CardHeader>
                <h6 className="title d-inline">Tasks(5)</h6>
                <p className="card-category d-inline"> today</p>
                <UncontrolledDropdown>
                  <DropdownToggle
                    caret
                    className="btn-icon"
                    color="link"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <i className="tim-icons icon-settings-gear-63" />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="dropdownMenuLink" right>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Action
                    </DropdownItem>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Another action
                    </DropdownItem>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Something else
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardHeader>
              <CardBody>
                <div className="table-full-width table-responsive">
                  <Table>
                    <tbody>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Update the Documentation</p>
                          <p className="text-muted">
                            Dwuamish Head, Seattle, WA 8:47 AM
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip636901683"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip636901683"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input
                                defaultChecked
                                defaultValue=""
                                type="checkbox"
                              />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">GDPR Compliance</p>
                          <p className="text-muted">
                            The GDPR is a regulation that requires businesses to
                            protect the personal data and privacy of Europe
                            citizens for transactions that occur within EU
                            member states.
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip457194718"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip457194718"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Solve the issues</p>
                          <p className="text-muted">
                            Fifty percent of all respondents said they would be
                            more likely to shop at a company
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip362404923"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip362404923"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Release v2.0.0</p>
                          <p className="text-muted">
                            Ra Ave SW, Seattle, WA 98116, SUA 11:19 AM
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip818217463"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip818217463"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Export the processed files</p>
                          <p className="text-muted">
                            The report also shows that consumers will not easily
                            forgive a company once a breach exposing their
                            personal data occurs.
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip831835125"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip831835125"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Arival at export process</p>
                          <p className="text-muted">
                            Capitol Hill, Seattle, WA 12:34 AM
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip217595172"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip217595172"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
*/
export default Dashboard;
